import { t } from '@/lib/i18n';
import type { RorosCanvasBlocksDTO, RorosCanvasItemDTO } from '@/types/roros/canvases';
import { CanvasBlock } from './CanvasBlock';
import { CanvasShell } from './CanvasShell';
import { AI_GAP_BLOCK_KEYS, BMC_BLOCKS, BMC_BOTTOM_BLOCKS } from './canvasConfig';

interface BusinessModelCanvasProps {
  canEdit: boolean;
}

export function BusinessModelCanvas({ canEdit }: BusinessModelCanvasProps) {
  return (
    <CanvasShell
      type="bmc"
      title={t('Business Model Canvas')}
      description={t('Map the nine building blocks of your business model as editable sticky notes.')}
      testId="business-model-canvas"
      canEdit={canEdit}
    >
      {({ blocks, canEdit: shellCanEdit, isSaving, isGenerating, aiAvailable, saveBlocks, regenerateBlock }) => {
        function updateBlock(blockKey: string, items: RorosCanvasItemDTO[]) {
          saveBlocks({
            ...blocks,
            [blockKey]: { items },
          } as RorosCanvasBlocksDTO);
        }

        return (
          <div className="space-y-3">
            <div className="grid grid-cols-1 gap-3 lg:grid-cols-5" data-testid="bmc-top-grid">
              {BMC_BLOCKS.map((block) => (
                <CanvasBlock
                  key={block.key}
                  blockKey={block.key}
                  title={t(block.label)}
                  block={blocks[block.key]}
                  canEdit={shellCanEdit}
                  isSaving={isSaving}
                  isGenerating={isGenerating}
                  onItemsChange={(items) => updateBlock(block.key, items)}
                  onRegenerate={() => regenerateBlock(block.key)}
                  showAiConfigureAffordance={!aiAvailable && AI_GAP_BLOCK_KEYS.includes(block.key) && (blocks[block.key]?.items ?? []).length === 0}
                  className={block.className}
                />
              ))}
            </div>
            <div className="grid grid-cols-1 gap-3 lg:grid-cols-2" data-testid="bmc-bottom-grid">
              {BMC_BOTTOM_BLOCKS.map((block) => (
                <CanvasBlock
                  key={block.key}
                  blockKey={block.key}
                  title={t(block.label)}
                  block={blocks[block.key]}
                  canEdit={shellCanEdit}
                  isSaving={isSaving}
                  isGenerating={isGenerating}
                  onItemsChange={(items) => updateBlock(block.key, items)}
                  onRegenerate={() => regenerateBlock(block.key)}
                  showAiConfigureAffordance={!aiAvailable && AI_GAP_BLOCK_KEYS.includes(block.key) && (blocks[block.key]?.items ?? []).length === 0}
                />
              ))}
            </div>
          </div>
        );
      }}
    </CanvasShell>
  );
}
